module.exports = __webpack_public_path__ + "media/images/profile_header.orig-0b36d6255a7cf1b95e9acae919549913.jpg";